export default __webpack_public_path__ + "static/media/jed.2ca20975.jpeg";